// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * ARCHAT - Normalización de idioma (fuente única frontend)
 * Acepta es-AR, es_AR, zh-CN, pt-BR, etc. y devuelve código canónico.
 * @file frontend/src/i18n/langNormalize.js
 */

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './supportedLanguages.js';

/** Idiomas soportados (códigos canónicos) */
export const SUPPORTED_LANGS = [...SUPPORTED_LANGUAGES];

/** Mapa de códigos regionales/variantes → canónico */
const LANG_MAP = {
  'es-ar': 'es',
  'es-419': 'es',
  'es-es': 'es',
  'es-mx': 'es',
  'es-cl': 'es',
  'es-co': 'es',
  'en-us': 'en',
  'en-gb': 'en',
  'en-au': 'en',
  'pt-br': 'pt',
  'pt-pt': 'pt',
  'zh-cn': 'zh',
  'zh-hans': 'zh',
  'zh-tw': 'zh',
  'zh-hant': 'zh',
  'ja-jp': 'ja',
  'ko-kr': 'ko',
  'hi-in': 'hi',
  'ar-sa': 'ar',
  'ar-eg': 'ar',
  'de-de': 'de',
  'de-at': 'de',
  'fr-fr': 'fr',
  'it-it': 'it',
  'ru-ru': 'ru',
  'nl-nl': 'nl',
  'tr-tr': 'tr',
  'pl-pl': 'pl',
  'sv-se': 'sv',
  'el-gr': 'el',
  'he-il': 'he'
};

/**
 * Normaliza un código de idioma a uno canónico soportado.
 * @param {string|null|undefined} input - Código de idioma (ej. "es-AR", "zh-CN", "en_US")
 * @returns {string} Código canónico ('es', 'en', ...) o DEFAULT_LANGUAGE si no soportado
 */
export function normalizeLang(input) {
  if (input == null || input === '') {
    return DEFAULT_LANGUAGE;
  }
  let s = String(input).trim().toLowerCase().replace(/_/g, '-');
  if (!s) return DEFAULT_LANGUAGE;
  // Ya es canónico
  if (SUPPORTED_LANGS.includes(s)) return s;
  // Mapeo explícito
  if (LANG_MAP[s]) return LANG_MAP[s];
  // sv-* → sv
  if (s.startsWith('sv-')) return 'sv';
  // ar-* → ar
  if (s.startsWith('ar-')) return 'ar';
  // he-* → he
  if (s.startsWith('he-')) return 'he';
  // Solo los dos primeros caracteres (ej. "es" de "es-AR" ya tratado; "zh" de "zh-xx")
  const base = s.split('-')[0];
  if (SUPPORTED_LANGS.includes(base)) return base;
  return DEFAULT_LANGUAGE;
}

/**
 * Resuelve idioma con prioridad: input → localStorage key → navigator → 'es'
 * @param {string|null|undefined} explicitLang - Idioma explícito (query, prop)
 * @param {string|null} storedLang - Valor en localStorage (ej. archat_lang)
 * @param {string} navigatorLang - navigator.language
 * @returns {string} Código canónico
 */
export function resolveLang(explicitLang, storedLang, navigatorLang = '') {
  const fromExplicit = explicitLang != null && String(explicitLang).trim() !== '';
  if (fromExplicit) return normalizeLang(explicitLang);
  if (storedLang != null && String(storedLang).trim() !== '') return normalizeLang(storedLang);
  if (navigatorLang && String(navigatorLang).trim() !== '') return normalizeLang(navigatorLang);
  return DEFAULT_LANGUAGE;
}
